var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-text" }, [
    _c(
      "div",
      { staticClass: "image-text-wrapper page-layout__section" },
      [
        _c(
          "div",
          { staticClass: "image-text__text-wrapper" },
          [
            _c("h3", { staticClass: "image-text__headline" }, [
              _vm._v(_vm._s(_vm.settings.title))
            ]),
            _c("p", { staticClass: "image-text__body" }, [
              _vm._v(_vm._s(_vm.settings.body))
            ]),
            _c("h4", { staticClass: "image-text__subheadline" }, [
              _vm._v(_vm._s(_vm.settings.sub_headline))
            ]),
            _c("base-button", { attrs: { href: _vm.settings.cta_url } }, [
              _vm._v(_vm._s(_vm.settings.cta_text))
            ])
          ],
          1
        ),
        _c(
          _vm.images.length > 1 ? "VueSlickCarousel" : "div",
          _vm._b(
            { tag: "div", staticClass: "image-text__image-wrapper" },
            "div",
            _vm.sliderSettings,
            false
          ),
          _vm._l(_vm.images, function(image, index) {
            return _c("img", {
              staticClass: "image-text__image",
              attrs: { src: image.src, alt: image.alt, loading: "lazy" }
            })
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }